const interfacePhrases = {
    rate_limited: 'Fréquence limitée',
    limit_exceeded: 'Limite dépassée',
    used: 'Utilisation',
    identifier: 'Identifiant',
    verification: 'Vérification',
    messages: 'Messages',
    data: 'Données',
    custom: 'Personnalisé',
    management_api: 'API de gestion {{product}}',
    management_api_role_description: 'Ce rôle intégré donne accès à l’API de gestion.',
    client_credentials: 'Identifiants client',
    authentication_request: 'Demande d’authentification',
    callback: 'Retour d’authentification',
    help_title: 'Centre d’aide iden',
    help_subtitle: 'De l’aide sans quitter votre espace de travail',
    open_help: 'Ouvrir la page d’aide complète',
    close_help: 'Fermer l’aide',
    about: 'À propos et logiciels libres',
    open_navigation: 'Ouvrir la navigation',
    close_navigation: 'Fermer la navigation',
    development_enabled: 'Fonctionnalités de développement activées',
    beta: 'Bêta',
    impersonation: 'Usurpation d’identité',
    key: 'Clé',
    value: 'Valeur',
    error: 'Erreur',
    details: 'Détails techniques',
    callback_failed: 'Impossible de terminer le retour de connexion.',
    back_sign_in: 'Retour à la connexion',
    powered_by: 'Propulsé par',
    avatar: 'Avatar',
    logo: 'Logo',
    qr_code: 'Code QR',
    sample_title: 'Vous souhaitez voir un exemple ?',
    sample_description: 'Découvrez une application utilisant ce guide.',
    sample_action: 'Voir l’exemple',
    further_readings: 'Pour aller plus loin',
    complete_guide: 'Guide complet',
    custom_domains_notice: 'Après l’ajout de <a>domaines personnalisés</a>, vous pouvez utiliser ce point de terminaison : <code>{{endpoint}}</code>.',
    my_project: 'Mon projet',
    my_secret: 'Mon secret',
    my_token: 'Mon jeton',
    role_example: 'Lecteur',
    reset_retry: 'Réinitialiser la configuration et réessayer',
    open_dev_panel: 'Ouvrir le panneau développeur',
    close_dev_panel: 'Fermer le panneau développeur',
    configuration: 'Configuration',
    app_id: 'Identifiant de l’application',
    extra_parameters: 'Paramètres de connexion supplémentaires',
    prompt: 'Invite d’authentification',
    scope: 'Portée',
    resource: 'Ressource',
    resources_space_delimited: 'Ressources (séparées par des espaces)',
    sign_out_to_apply: 'Déconnectez-vous pour appliquer les modifications.',
    refresh_token_grant: 'Autorisation par jeton de renouvellement',
    organization_id: 'Identifiant de l’organisation',
    console_result: 'Consultez la console du navigateur pour voir le résultat.',
    request_token: 'Demander un jeton',
    user_info: 'Informations utilisateur',
    get_id_token_claims: 'Obtenir les revendications du jeton d’identité',
    fetch_user_info: 'Récupérer les informations utilisateur',
    device_initializing: 'Initialisation de l’autorisation de l’appareil…',
    device_success: 'Vous êtes connecté à l’application de démonstration.',
    sign_in_information: 'Vos informations de connexion :',
    email: 'E-mail',
    username: 'Nom d’utilisateur',
    user_id: 'Identifiant utilisateur',
    sign_out_demo: 'Se déconnecter de la démonstration',
    device_expired: 'Code de l’appareil expiré',
    generic_error: 'Une erreur s’est produite',
    device_expired_description: 'Le code de l’appareil a expiré. Réessayez pour obtenir un nouveau code.',
    sign_in_title: 'Connectez-vous à votre compte',
    scan_instruction: 'Scannez le code QR ou ouvrez cette adresse sur un autre appareil :',
    one_time_code: 'Saisissez le code à usage unique',
    token_info: 'Informations du jeton',
    get_access_token: 'Obtenir un jeton d’accès',
    context_unavailable: 'Impossible de charger les informations du compte.',
    not_initialized: 'Les informations du compte ne sont pas initialisées.',
    not_set: 'Non défini',
    configured: 'Configuré',
    password: 'Mot de passe',
    phone: 'Numéro de téléphone',
    search_help: 'Rechercher dans l’aide',
    language: 'Langue',
    menu: 'Menu',
    compatibility_notice: 'Compatibilité : les noms hérités des SDK, paquets, protocoles, composants et en-têtes de requête Logto restent inchangés.',
    source: 'Source',
    upstream_repository: 'Dépôt d’origine',
    current_fork: 'Dépôt actuel',
    license_notice: 'iden repose sur Logto, un logiciel libre distribué sous Mozilla Public License 2.0.',
    about_description: 'Informations produit et mentions des logiciels libres.',
    page_not_found: 'Page introuvable',
    page_not_found_description: 'Cette page est indisponible. Retournez au centre d’aide pour continuer.',
    introduction: 'Introduction',
    quick_starts: 'Démarrage rapide',
    integration: 'Intégration',
    end_user_flows: 'Parcours utilisateur',
    authorization: 'Autorisation',
    user_management: 'Gestion des utilisateurs',
    security: 'Sécurité',
    customization: 'Personnalisation',
    connectors: 'Connecteurs',
    organizations: 'Organisations',
    self_hosting: 'Auto-hébergement',
    continue: 'Continuer',
    loading: 'Chargement…',
    save: 'Enregistrer',
    saved: 'Enregistré',
    try_again: 'Réessayer',
    client_id: 'Identifiant client',
    client_secret: 'Secret client',
    redirect_uri: 'URI de redirection',
    status: 'État',
    type: 'Type',
    permissions: 'Permissions',
    token_data: 'Données du jeton',
    context_data: 'Données de contexte',
    jwt_extra_claims: 'Revendications supplémentaires du jeton',
    action_result: 'Résultat de l’action',
    social_account_already_linked: 'Ce compte social est déjà associé.',
};
export default Object.freeze(interfacePhrases);
